import { CertificateType, ICertificate } from "../../../models/certificate";
import { IIDDataSet } from "../../../models/crewMember";
import { formatDateForCertificateView, Gender } from "../../../models/common";
import background_1 from "../../../images/CH_patent_card_2023_background_page-0001.jpg";
import background_2 from "../../../images/CH_patent_card_2023_background_page-0002.jpg";

type Props = {
    certificate: ICertificate;
    idDataSet: IIDDataSet;
    imageBase64: string;
    qrBase64: string;
};

export const CCNRExpertCardView = ({ certificate, idDataSet, imageBase64, qrBase64 }: Props) => {
    const getExpertType = () => {
        const isFemale = certificate.gender === Gender.Female;
        if (certificate.type === CertificateType.UcqLngExpert) {
            return isFemale ? "LNG-Sachkundige" : "LNG-Sachkundiger";
        }
        return isFemale
            ? "Sachkundige für die Fahrgastschifffahrt"
            : "Sachkundiger für die Fahrgastschifffahrt";
    };

    const getUserImageSrc = () => `data:image/jpg;base64,${imageBase64}`;

    return (
        <div id="ccnr-expert-card-view">
            <section
                style={{
                    fontSize: "8.5px",
                    width: "86.5mm",
                    height: "54mm",
                    maxWidth: "86.5mm",
                    maxHeight: "54mm",
                    fontFamily: "Barlow",
                    backgroundImage: `url(${background_1})`,
                    backgroundSize: "cover",
                    border: "0.5px dashed black",
                    lineHeight: "1",
                }}
            >
                <div style={{ display: "flex", marginLeft: "10px", marginTop: "10px" }}>
                    <div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                fontFamily: "Barlow Medium",
                            }}
                        >
                            <span style={{ marginTop: "50px" }}>
                                Befähigungszeugnis für die Binnenschifffahrt
                            </span>
                            <span
                                style={{
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                    fontSize: "9.5px",
                                }}
                            >
                                {getExpertType()}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    style={{ display: "flex", justifyContent: "space-between", marginLeft: "10px" }}
                >
                    <div style={{ display: "flex", flexDirection: "column", width: "70%" }}>
                        <div style={{ marginBottom: "5px" }}>
                            <span style={{ display: "inline-block", width: "15px" }}>1.</span>
                            <span>
                                {idDataSet.nonLatinLastName
                                    ? idDataSet.nonLatinLastName
                                    : idDataSet.lastName}
                            </span>
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                            <span style={{ display: "inline-block", width: "15px" }}>2.</span>
                            <span>
                                {idDataSet.nonLatinFirstName
                                    ? idDataSet.nonLatinFirstName
                                    : idDataSet.firstName}
                            </span>
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px" }}>
                            <div style={{ width: "40%" }}>
                                <span style={{ display: "inline-block", width: "15px" }}>3a.</span>
                                <span>{formatDateForCertificateView(idDataSet.dateOfBirth)}</span>
                            </div>
                            <div>
                                <span style={{ display: "inline-block", width: "15px" }}>3b.</span>
                                <span>
                                    {idDataSet.nonLatinPlaceOfBirth
                                        ? idDataSet.nonLatinPlaceOfBirth
                                        : idDataSet.placeOfBirth}
                                </span>
                            </div>
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <span style={{ display: "inline-block", width: "15px" }}>4.</span>
                            <span>{idDataSet.cid}</span>
                        </div>
                        <div style={{ display: "flex", marginBottom: "5px" }}>
                            <div style={{ width: "40%" }}>
                                <span style={{ display: "inline-block", width: "15px" }}>7.</span>
                                <span>{formatDateForCertificateView(certificate.startDate)}</span>
                            </div>
                            <div>
                                <span style={{ display: "inline-block", width: "15px" }}>8.</span>
                                <span>{formatDateForCertificateView(certificate.endDate)}</span>
                            </div>
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                            <span style={{ display: "inline-block", width: "15px" }}>9.</span>
                            <span>Port of Switzerland</span>
                        </div>
                    </div>
                    <div>
                        <img
                            src={getUserImageSrc()}
                            alt="User"
                            style={{
                                width: "20mm",
                                height: "25mm",
                                marginRight: "10px",
                                marginTop: "-10px",
                            }}
                        />
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "5px",
                        marginRight: "10px",
                    }}
                >
                    <div>
                        <span style={{ display: "inline-block", width: "15px" }}>6.</span>
                        <span style={{ fontFamily: "OCR B Std" }}>{certificate.qualificationID}</span>
                    </div>
                </div>
            </section>
            <section
                style={{
                    marginTop: "20px",
                    fontSize: "8.5px",
                    width: "86.5mm",
                    height: "54mm",
                    maxWidth: "86.5mm",
                    maxHeight: "54mm",
                    fontFamily: "Barlow",
                    backgroundImage: `url(${background_2})`,
                    backgroundSize: "cover",
                    border: "0.5px dashed black",
                    lineHeight: "1",
                }}
            >
                {/* Back page: QR code only, no text */}
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "61px" }}>
                    <div>
                        <img
                            src={`data:image/jpg;base64,${qrBase64}`}
                            alt="QR"
                            style={{
                                width: "22mm",
                                height: "22mm",
                                marginRight: "6px",
                            }}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};
